import iServicesHeart from "../../assets/icons/service-page/services-page-heart-img.png";
import iServicesStarImg from "../../assets/icons/service-page/services-page-star-img.svg";
import PageTitle from "../../components/common/page-title/page-title";
import ServiceCardList from "../../components/common/service-card-list/service-card-list";
import { useWidth } from "../../hooks/use-width";
import "./services-page.sass";

const ServicesPage = () => {
  const { isMobileWidth } = useWidth();
  return (
    <div className="page services-page">
      <div className="services-page__title">
        <PageTitle>
          От стратегии{isMobileWidth && <br />} и креативной концепции до
          реализации
        </PageTitle>

        <div className="services-page__subtitle">
          делаем всё, чтобы бренд запомнили
        </div>
      </div>

      <ServiceCardList />

      <img
        src={iServicesHeart}
        className="img-absolute services-page__heart"
        alt=""
      />
      <img
        src={iServicesStarImg}
        className="img-absolute services-page__star"
        alt=""
      />
    </div>
  );
};

export default ServicesPage;
